import { render, staticRenderFns } from "./iconVoltage.vue?vue&type=template&id=29e14a05&"
import script from "./iconVoltage.vue?vue&type=script&lang=js&"
export * from "./iconVoltage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports